export const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID
export const CLIENT_SECRET = process.env.REACT_APP_GOOGLE_CLIENT_SECRET
export const REDIRECT_URI = process.env.REACT_APP_GOOGLE_REDIRECT_URI
